var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('nav-bar'),_c('home-banner'),_c('home-why-synx'),_c('home-how-it-works'),_c('home-process'),_c('home-ready'),_c('home-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }